import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { useGetVariantbyProductIdQuery, useStoreVariantProductMutation, useStoreProductTypeMutation, useGetVariantStockQuery, useBulkUpdateVarientStockMutation } from "../../Services/StockManagemntAPI";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

function AddStockTable({ productType }) {
    const { id } = useParams();
    const navigate = useNavigate();
    const [rows, setRows] = useState([]);
    const [validationErrors, setValidationErrors] = useState({});

    const [StoreProductType] = useStoreProductTypeMutation();
    const { data: variantsData, isLoading } = useGetVariantbyProductIdQuery(id);
    const [addStock, { isLoading: addLoading }] = useStoreVariantProductMutation();
    const [updateStock, { isLoading: updateLoading }] = useBulkUpdateVarientStockMutation();
    const { data: variantStockData, refetch: refetchVariantStock } = useGetVariantStockQuery(id);


    console.log("variantStockData", variantsData)
    useEffect(() => {
        refetchVariantStock();
    }, [refetchVariantStock]);

    useEffect(() => {
        if (variantStockData?.variant_combinations?.length > 0) {
            setRows(
                variantStockData.variant_combinations?.map(item => ({
                    variants: item.variant_combinations?.map(v => String(v)),
                    sku: item.sku || "",
                    price: item.price || "",
                    stock: item.stock || ""
                }))
            );
        } else if (variantsData?.variants?.length > 0) {
            setRows([
                {
                    variants: new Array(variantsData.variants.length).fill(""),
                    sku: "",
                    price: "",
                    stock: ""
                }
            ]);
        }
    }, [variantStockData, variantsData]);

    const handleAddRow = () => {
        setRows([...rows, { variants: new Array(variantsData?.variants?.length).fill(""), sku: "", price: "", stock: "" }]);
    };

    const handleRemoveRow = (index) => {
        setRows(rows.filter((_, i) => i !== index));

        // Remove validation errors for the removed row
        const updatedErrors = { ...validationErrors };
        delete updatedErrors[index];
        setValidationErrors(updatedErrors);
    };

    const handleChange = (index, field, value, variantIndex = null) => {
        const updatedRows = [...rows];
    
        if (field === "variants") {
            if (!Array.isArray(updatedRows[index].variants)) {
                updatedRows[index].variants = [];
            }
            updatedRows[index].variants[variantIndex] = value;
        } else {
            updatedRows[index][field] = value;
        }
    
        setRows(updatedRows);
    
        // Clear validation errors when field is updated
        if (validationErrors[index]?.[field]) {
            const updatedErrors = { ...validationErrors };
            delete updatedErrors[index][field];
            setValidationErrors(updatedErrors);
        }
    };
    

    // const validateFields = () => {
    //     const errors = {};
    //     rows.forEach((row, rowIndex) => {
    //         errors[rowIndex] = {};
    //         if (row.variants.some(v => v === "")) {
    //             errors[rowIndex]["variants"] = "Variant selection is required.";
    //         }
    //         if (!row.sku.trim()) {
    //             errors[rowIndex]["sku"] = "SKU is required.";
    //         }
    //         if (!row.price.trim()) {
    //             errors[rowIndex]["price"] = "Price is required.";
    //         }
    //         if (!row.stock.trim()) {
    //             errors[rowIndex]["stock"] = "Stock is required.";
    //         }

    //         if (Object.keys(errors[rowIndex]).length === 0) {
    //             delete errors[rowIndex]; // Remove empty error objects
    //         }
    //     });

    //     setValidationErrors(errors);
    //     return Object.keys(errors).length === 0; // Returns true if no errors
    // };

    const handleSubmit = async (e) => {
        e.preventDefault();
    
        // Validate required fields
        for (const row of rows) {
            if (
                row.variants.some(v => !v.trim()) || // Ensure all variant selections are made
                !row.sku.trim() ||
                row.price === "" || isNaN(row.price) || // Ensure price is not empty and is a number
                row.stock === "" || isNaN(row.stock) // Ensure stock is not empty and is a number
            ) {
                alert("All fields are required. Please fill in all the details and Stock field should be greater than 0");
                return;
            }
        }
    
        const formattedData = {
            rows: rows.map(row => ({
                variants: row.variants.map(v => v === "all" ? "all" : Number(v)), // Keep "all" as string
                sku: row.sku.trim(),
                stock_type: 1,
                price: parseFloat(row.price),
                stock: parseInt(row.stock)
            }))
        };
    
        const productTypeData = {
            product_id: id,
            is_variant: productType
        };
    
        try {
            await StoreProductType(productTypeData).unwrap();
    
            if (variantStockData?.variant_combinations?.length > 0) {
                await updateStock({ id, formattedData }).unwrap();
                alert("Stock updated successfully!");
            } else {
                await addStock({ id, formattedData }).unwrap();
                alert("Stock added successfully!");
            }
    
            navigate("/products");
        } catch (error) {
            alert(error.data?.message || "Something went wrong");
        }
    };
    

    if (isLoading) return <p>Loading variants...</p>;

    return (
        <div>
          {variantsData !== undefined ?  (<form onSubmit={handleSubmit}>
                <div className="table-responsive">
                    <table className="table variant-stock-table">
                        <thead>
                            <tr>
                                {variantsData?.variants?.map((variant, i) => (
                                    <th key={i}>{variant.name}</th>
                                ))}
                                <th>SKU</th>
                                <th>Price</th>
                                <th>Stock</th>
                                <th>Actions</th>
                            </tr>
                        </thead>
                        <tbody>
                            {rows?.map((row, index) => (
                                <tr key={index}>
                                    {variantsData?.variants?.map((variant, i) => (
                                        <td key={i}>
                                            <select
                                                value={row?.variants?.[i]}
                                                onChange={(e) => handleChange(index, "variants", e.target.value, i)}
                                                className="form-control"
                                                style={{ width: "200px" }}
                                            >
                                                <option value="">Select</option>
                                                <option value="all">All</option>
                                                {variant?.values?.map(v => (
                                                    <option key={v.id} value={v.id}>{v.value}</option>
                                                ))}
                                            </select>
                                            {validationErrors[index]?.variants && <p className="text-danger">{validationErrors[index].variants}</p>}
                                        </td>
                                    ))}
                                    <td>
                                        <input type="text" value={row.sku} style={{ width: "150px" }} onChange={(e) => handleChange(index, "sku", e.target.value)} className="form-control" />
                                        {validationErrors[index]?.sku && <p className="text-danger">{validationErrors[index].sku}</p>}
                                    </td>
                                    <td>
                                        <input type="number" value={row.price} onChange={(e) => handleChange(index, "price", e.target.value)} className="form-control" />
                                        {validationErrors[index]?.price && <p className="text-danger">{validationErrors[index].price}</p>}
                                    </td>
                                    <td>
                                        <input type="number" value={row.stock} onChange={(e) => handleChange(index, "stock", e.target.value)} className="form-control" />
                                        {validationErrors[index]?.stock && <p className="text-danger">{validationErrors[index].stock}</p>}
                                    </td>
                                    <td>
                                        <button type="button" className="btn btn-danger" onClick={() => handleRemoveRow(index)}><FontAwesomeIcon icon={faTrash} /></button>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>

                <div className="mt-4">
                    <button type="button" onClick={handleAddRow} className="btn btn-success mt-2"><FontAwesomeIcon icon={faPlus} /> Add Row</button>
                    <button type="submit" className="btn btn-primary mt-2 ml-5" disabled={addLoading || updateLoading}>{isLoading || updateLoading ? "Submitting..." : "Submit"}</button>
                </div>
            </form>):(
                <h5>No variants found. Please add variants before adding stock.</h5>
            )}
        </div>
    );
}

export default AddStockTable;
